import dayjs from "dayjs";
import { INursingCarePlan, IOption } from "../../../type";
import { HOURS_PER_DAY } from "constant/date";
import { Checkbox } from "antd";
import Styles from "./styled";
import { frequencyOptions, shiftOptions } from "../../../constants";

interface IProps {
  nursingCarePlan: INursingCarePlan;
  serviceOptions: IOption[];
  serviceTypeOptions: IOption[];
}

const TableSchedule = ({
  nursingCarePlan,
  serviceOptions,
  serviceTypeOptions,
}: IProps) => {
  const schedules = (nursingCarePlan.schedules || []).sort((item1, item2) => item1.sort_index - item2.sort_index).map((schedule) => {
    const startHour = dayjs(schedule?.start_time)?.get("seconds");
    const endHour = dayjs(schedule?.end_time)?.get("seconds");

    const regisDays = {
      "1": false,
      "2": false,
      "3": false,
      "4": false,
      "5": false,
      "6": false,
      "0": false,
    };

    schedule?.schedule_routines?.forEach((routine) => {
      const key = String(routine.regis_day) as keyof typeof regisDays;
      regisDays[key] = true;
    });

    return {
      ...schedule,
      ...regisDays,
      start_hour:
        startHour > HOURS_PER_DAY ? startHour - HOURS_PER_DAY : startHour,
      start_minute: dayjs(schedule?.start_time).utc().get("minutes"),
      end_hour: endHour > HOURS_PER_DAY ? endHour - HOURS_PER_DAY : endHour,
      end_minute: dayjs(schedule?.end_time).utc().get("minutes"),
    };
  });

  const formatTime = (hour: number, minute: number) =>
    `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;

  const getServiceName = (id: number) =>
    serviceOptions.find((x) => x.value === id)?.label;

  const getServiceTypeName = (id: number) =>
    serviceTypeOptions.find((x) => x.value === id)?.label;

  const getFrequency = (value: string) =>
    frequencyOptions.find((x) => x.value === value)?.label;

  const getShift = (value: string) =>
    shiftOptions.find((x) => x.value === value)?.label;

  return (
    <Styles>
      <table className="schedule-table table-fixed w-full">
        <colgroup>
          <col /> {/* サービス名称 */}
          <col style={{ width: "100px" }} /> {/* 提供時間 */}
          <col style={{ minWidth: "100px" }} /> {/* サービス内容 */}
          <col style={{ width: "25px" }} /> {/* 月 */}
          <col style={{ width: "25px" }} /> {/* 火 */}
          <col style={{ width: "25px" }} /> {/* 水 */}
          <col style={{ width: "25px" }} /> {/* 木 */}
          <col style={{ width: "25px" }} /> {/* 金 */}
          <col style={{ width: "25px" }} /> {/* 土 */}
          <col style={{ width: "25px" }} /> {/* 日 */}
          <col style={{ width: "70px" }} /> {/* 頻度 */}
          <col style={{ width: "80px" }} /> {/* 対応シフト */}
        </colgroup>
        <thead>
          <tr>
            <th>サービス名称</th>
            <th>提供時間</th>
            <th>サービス内容</th>
            <th>月</th>
            <th>火</th>
            <th>水</th>
            <th>木</th>
            <th>金</th>
            <th>土</th>
            <th>日</th>
            <th>頻度</th>
            <th>対応シフト</th>
          </tr>
        </thead>

        <tbody>
          {schedules.map((record, index) => (
            <tr key={index}>
              <td>{getServiceName(record.service_id)}</td>

              <td>
                {formatTime(record.start_hour, record.start_minute)}
                <span className="px-1">-</span>
                {formatTime(record.end_hour, record.end_minute)}
              </td>

              <td className="">{getServiceTypeName(record.service_type_id)}</td>
              <td>
                <Checkbox disabled checked={record["1"]} />
              </td>
              <td>
                <Checkbox disabled checked={record["2"]} />
              </td>
              <td>
                <Checkbox disabled checked={record["3"]} />
              </td>
              <td>
                <Checkbox disabled checked={record["4"]} />
              </td>
              <td>
                <Checkbox disabled checked={record["5"]} />
              </td>
              <td>
                <Checkbox disabled checked={record["6"]} />
              </td>
              <td>
                <Checkbox disabled checked={record["0"]} />
              </td>

              <td>{getFrequency(record.frequency)}</td>

              <td>{getShift(record.shift_type)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Styles>
  );
};

export default TableSchedule;
